import { FC } from "react"
import cx from "classnames"
import { MdMoreVert } from "react-icons/md"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const MoreIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <MdMoreVert
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default MoreIcon
